import * as React from "react"
import CountUp, { startAnimation } from "react-countup"
import {
  MainContainer,
  InnerContainer,
  Block,
  Number,
  Text,
} from "./countupstyles"
import VisibilitySensor from "react-visibility-sensor-v2"

const Countup = () => {
  const items = [
    { number: "150", text: "Countries" },
    { number: "100", text: "Speakers" },
    { number: "20", text: "Topics" },
    { number: "30", text: "Sessions" },
  ]
  return (
    <MainContainer>
      <InnerContainer>
        {items.map(node => (
          <Block>
            <Number>
              <CountUp end={node.number}>
                {({ countUpRef, start }) => (
                  <VisibilitySensor onChange={start} delayedCall>
                    <span ref={countUpRef} />
                  </VisibilitySensor>
                )}
              </CountUp>
              +
            </Number>
            <Text text style={{ fontSize: "30px" }}>
              {node.text}
            </Text>
          </Block>
        ))}
      </InnerContainer>
    </MainContainer>
  )
}

export default Countup
